import React from 'react';
import { ContentPage } from './MerchandiserLayout';
import GroupSettingsPage from '../../../../components/DeviceManager/Group/GroupSettingsPage';

function MerchandiserSettings() {
  return (
    <ContentPage variant="elevation" sx={{ flex: '1', width: '100%' }}>
      <GroupSettingsPage />
    </ContentPage>
  );
}

export default MerchandiserSettings;
